import React, { useState, useEffect, useCallback } from 'react'
import "./movieGrid.scss";
import MovieCard from "../movie-card/MovieCard";
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Button, { OutlineButton } from '../button/Button';
import Input from '../input/Input';

const MovieGrid = props => {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);

    const { keyword } = useParams();
    // console.log(keyword);

    useEffect(() => {
        const getList = async () => {
            let response = null;

            if (keyword === undefined) {
                switch (props.category) {
                    case 'movie':
                        response = await axios.get(`https://api.themoviedb.org/3/movie/upcoming?api_key=088f4df643022cbbe2a297babd84490c`);
                        break;
                    default:
                        response = await axios.get(`https://api.themoviedb.org/3/tv/popular?api_key=088f4df643022cbbe2a297babd84490c`)
                }
            } else {
                response = await axios.get(`https://api.themoviedb.org/3/search/${props.category}/?api_key=088f4df643022cbbe2a297babd84490c&query=${keyword}`, {})
            }
            setItems(response.data.results);
            setTotalPage(response.data.total_pages);
        }
        getList();
    }, [props.category, keyword]);

    const loadmore = async () => {
        let response = null;

        if (keyword === undefined) {
            switch (props.category) {
                case 'movie':
                    response = await axios.get(`https://api.themoviedb.org/3/movie/upcoming?api_key=088f4df643022cbbe2a297babd84490c&page=${page + 1}`);
                    break;
                default:
                    response = await axios.get(`https://api.themoviedb.org/3/tv/popular?api_key=088f4df643022cbbe2a297babd84490c&page=${page + 1}`)
            }
        } else {
            response = await axios.get(`https://api.themoviedb.org/3/search/${props.category}/?api_key=088f4df643022cbbe2a297babd84490c&query=${keyword}&page=${page + 1}`, {})
        }
        setItems([...items, ...response.data.results]);
        setPage(page + 1);
    }
    return (
        <>
            <div className="section mb-3">
                <MovieSearch category={props.category} keyword={keyword} />
            </div>
            <div className='movie-grid'>
                {
                    items.map((items, index) => (
                        <MovieCard category={props.category} item={items} key={index} />
                    ))
                }
            </div>
            {
                page < totalPage ? (
                    <div className="movie-grid__loadmore">
                        <OutlineButton className='small' onClick={loadmore}>Load More</OutlineButton>
                    </div>
                ) : ""
            }
        </>
    )
}

export const MovieSearch = props => {
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState(props.keyword ? props.keyword : "");
    const goToSearch = useCallback(
        () => {
            if (keyword.trim().length > 0) {
                navigate(`/${props.category}/search/${keyword}`)
            }
        },
        [keyword, props.category, navigate]
    );

    useEffect(() => {
        const enterEvent = e => {
            e.preventDefault();
            if (e.keyCode === 13) {
                goToSearch();
            }
        }
        document.addEventListener('keyup', enterEvent);
        return () => {
            document.removeEventListener('keyup', enterEvent);
        };
    }, [keyword, goToSearch])
    return (
        <div className="movie-search">
            <Input
                type='text'
                placeholder='Enter Keyword'
                value={keyword}
                onChange={e => setKeyword(e.target.value)}

            />
            <Button className='small' onClick={goToSearch}>Search</Button>
        </div>
    )
}

export default MovieGrid